import { CdkStepperModule } from '@angular/cdk/stepper';
import { NgModule } from '@angular/core';

import { ApStepControlsDirective } from './step-controls/step-controls.directive';
import { ApStepperHeaderComponent } from './stepper-header/stepper-header.component';
import {
    ApStepComponent,
    ApStepperComponent,
    ApStepperDirective,
    ApStepperNextDirective,
    ApStepperPreviousDirective
} from './stepper.component';

const COMPONENTS = [ApStepComponent, ApStepperComponent, ApStepperHeaderComponent];
const DIRECTIVES = [ApStepperDirective, ApStepControlsDirective, ApStepperNextDirective, ApStepperPreviousDirective];

@NgModule({
    imports: [CdkStepperModule, ...COMPONENTS, ...DIRECTIVES],
    exports: [...COMPONENTS, ...DIRECTIVES]
})
export class ApStepperModule {}
